import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M12.602 5.2a3.6 3.6 0 1 0-7.201 0 3.6 3.6 0 0 0 7.2 0m-8.4 0a4.8 4.8 0 1 1 9.6 0 4.8 4.8 0 0 1-9.6 0m-2.4 13.2h14.4a5.485 5.485 0 0 0-5.487-5.4H7.288a5.49 5.49 0 0 0-5.486 5.4m-1.2.086A6.685 6.685 0 0 1 7.288 11.8h3.427a6.685 6.685 0 0 1 6.687 6.686c0 .615-.5 1.114-1.114 1.114H1.715a1.114 1.114 0 0 1-1.113-1.114"
    }, null, -1)
  ])))
}
export default { render: render }